import React, {useEffect, useRef} from "react";
import github from "../../assets/images/imageForAuthAnimation/git-hub-2.svg";
import gitlab from "../../assets/images/imageForAuthAnimation/git-lab-2.svg";
import trello from "../../assets/images/imageForAuthAnimation/tr-2.svg";
import jira from "../../assets/images/imageForAuthAnimation/jira-2.svg";
import notion from "../../assets/images/imageForAuthAnimation/notion-2.svg";
import shopify from "../../assets/images/imageForAuthAnimation/shopify-2.svg";
import chatgpt from "../../assets/images/imageForAuthAnimation/chatgpt.svg";
import claude from "../../assets/images/imageForAuthAnimation/claude.svg";
import tick from "../../assets/images/imageForAuthAnimation/tick-circle.svg";
import cross from "../../assets/images/imageForAuthAnimation/danger.svg";
import "./style.scss";

import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const brandsData = [
  {name: "Trello", icon: trello},
  {name: "Notion", icon: notion},
  {name: "Shopify", icon: shopify},
  {name: "GitLab", icon: gitlab},
  {name: "GitHub", icon: github},
  {name: "Jira", icon: jira},
  {name: "ChatGPT", icon: chatgpt},
  {name: "Claude", icon: claude},
];

const AuthRightAnimation = () => {
  const containerRef = useRef(null);
  const activeSlots = useRef(new Set());
  const activeBrands = useRef(new Set());

  useEffect(() => {
    const root = containerRef.current;
    if (!root) return;

    const slots = root.querySelectorAll(".anim-about__item");

    gsap.set(slots, {autoAlpha: 0});

    const resizeRoadmap = () => {
      const sections = root.querySelectorAll(".roadmap-section");

      sections.forEach((section) => {
        const wrapper = section.parentElement;
        const designWidth = parseInt(section.style.width);
        const parentWidth = wrapper.offsetWidth;

        const scale = parentWidth / designWidth;

        if (parentWidth < designWidth) {
          section.style.transform = `scale(${scale})`;
          wrapper.style.height = section.offsetHeight * scale + "px";
        } else {
          section.style.transform = "none";
          wrapper.style.height = "auto";
        }
      });
    };

    const getRandomItem = (arr) =>
      arr[Math.floor(Math.random() * arr.length)];

    const animateSlot = () => {
      const availableSlots = Array.from(slots).filter(
        (s) => !activeSlots.current.has(s)
      );

      if (!availableSlots.length) {
        setTimeout(animateSlot, 400);
        return;
      }

      const slot = getRandomItem(availableSlots);
      const availableBrands = brandsData.filter(
        (b) => !activeBrands.current.has(b.name)
      );

      if (!availableBrands.length) {
        setTimeout(animateSlot, 300);
        return;
      }

      const brand = getRandomItem(availableBrands);
      activeBrands.current.add(brand.name);

      activeSlots.current.add(slot);

      const brandIcon = slot.querySelector(".anim-about__item-brand");
      const nameText = slot.querySelector(".anim-about__item-name");
      const dangerIcon = slot.querySelector(
        ".anim-about__item-status--danger"
      );
      const successIcon = slot.querySelector(
        ".anim-about__item-status--success"
      );
      const iconWrapper = slot.querySelector(".anim-about__item-icons");

      brandIcon.src = brand.icon;
      nameText.textContent = brand.name;

      const tl = gsap.timeline({
        onComplete: () => {
          activeSlots.current.delete(slot);
          activeBrands.current.delete(brand.name);
          setTimeout(animateSlot, Math.random() * 400 + 200);
        },
      });

      tl.set(slot, {autoAlpha: 1})
        .set(dangerIcon, {autoAlpha: 1, display: "block"})
        .set(successIcon, {autoAlpha: 0, display: "none"})
        .set(nameText, {autoAlpha: 0})
        .set(iconWrapper, {autoAlpha: 0});

      tl.to(iconWrapper, {autoAlpha: 1, duration: 0.4})
        .to(nameText, {autoAlpha: 1, duration: 0.4}, "-=0.2")
        .to({}, {duration: 1})
        .to(dangerIcon, {autoAlpha: 0, display: "none", duration: 0.15})
        .to(successIcon, {autoAlpha: 1, display: "block", duration: 0.15})
        .to({}, {duration: 1})
        .to(slot, {autoAlpha: 0, duration: 0.4});
    };

    // start animation loop
    for (let i = 0; i < 5; i++) {
      setTimeout(animateSlot, i * 400);
    }

    // SVG animation
    const path = root.querySelector(
      ".anim-about__logo-svg g path[stroke]"
    );

    if (path) {
      const length = path.getTotalLength();

      gsap.set(path, {
        strokeDasharray: `80 150 80 ${length}`,
        strokeOpacity: 1,
      });

      gsap.to(path, {
        strokeDashoffset: -length,
        duration: 6,
        repeat: -1,
        ease: "none",
      });
    }

    window.addEventListener("resize", resizeRoadmap);
    resizeRoadmap();

    return () => {
      window.removeEventListener("resize", resizeRoadmap);
    };
  }, []);

  return (
    <main className="main" ref={containerRef}>
      <section className="hero section-padding">
        <div className="hero__container hero__container_about">
          <div className="roadmap-wrapper roadmap-wrapper_about">
            <div className="anim-about roadmap-section" style={{width: '800px'}}>
              <div className="anim-about__logo-wrapper">
                <svg
                  width="251"
                  height="289"
                  viewBox="0 0 251 289"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="anim-about__logo-svg"
                >
                  <mask
                    id="mask0_100_4963"
                    style={{maskType: 'luminance'}}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="251"
                    height="289"
                  >
                    <path
                      d="M232.163 0H18.6352C8.34325 0 0 8.34325 0 18.6352V269.433C0 279.725 8.34325 288.069 18.6352 288.069H232.163C242.455 288.069 250.798 279.725 250.798 269.433V18.6352C250.798 8.34325 242.455 0 232.163 0Z"
                      fill="white"
                    />
                  </mask>
                  <g mask="url(#mask0_100_4963)">
                    <path
                      className="js-rotate-ring-1"
                      d="M119.927 -6.18981C123.499 -7.23881 127.297 -7.23881 130.869 -6.18981L237.633 25.1716C245.898 27.5996 251.574 35.1826 251.574 43.7959V210.723C251.574 217.606 247.929 223.973 241.995 227.459L135.231 290.182C129.161 293.748 121.635 293.748 115.566 290.182L8.80191 227.459C2.86739 223.973 -0.777344 217.606 -0.777344 210.723V43.7959L-0.773458 43.3929C-0.599529 34.9465 5.02829 27.5616 13.1633 25.1716L119.927 -6.18981Z"
                      stroke="url(#paint0_linear_100_4963)"
                      stroke-width="2"
                    />
                    <path
                      className="js-rotate-ring-2"
                      d="M6.21094 49.0662C6.21094 40.803 11.6516 33.5268 19.5778 31.1912L120.13 1.55352C123.569 0.539453 127.228 0.539453 130.667 1.55352L231.219 31.1912C239.145 33.5268 244.586 40.803 244.586 49.0662V207.161C244.586 213.759 241.097 219.865 235.414 223.215L134.862 282.49C129.022 285.933 121.775 285.933 115.935 282.49L15.3826 223.215C9.6996 219.865 6.21094 213.759 6.21094 207.161V49.0662Z"
                      fill="url(#paint1_linear_100_4963)"
                    />
                    <g filter="url(#filter0_d_100_4963)">
                      <path
                        d="M149.471 86.1875H101.33C94.4684 86.1875 88.9062 91.7497 88.9062 98.6109V146.752C88.9062 153.613 94.4684 159.175 101.33 159.175H149.471C156.332 159.175 161.894 153.613 161.894 146.752V98.6109C161.894 91.7497 156.332 86.1875 149.471 86.1875Z"
                        fill="white"
                        fill-opacity="0.16"
                      />
                      <path
                        d="M140.213 104.838L127.757 100.173C126.466 99.6976 124.36 99.6976 123.069 100.173L110.614 104.838C108.213 105.744 106.266 108.552 106.266 111.112V129.456C106.266 131.29 107.465 133.713 108.937 134.8L121.393 144.108C123.59 145.761 127.191 145.761 129.388 144.108L141.843 134.8C143.315 133.69 144.516 131.29 144.516 129.456V111.112C144.538 108.552 142.591 105.744 140.213 104.838ZM133.283 117.521L123.545 127.258C123.205 127.598 122.775 127.757 122.345 127.757C121.915 127.757 121.484 127.598 121.144 127.258L117.52 123.589C116.864 122.933 116.864 121.846 117.52 121.189C118.177 120.532 119.264 120.532 119.921 121.189L122.367 123.635L130.905 115.097C131.562 114.44 132.649 114.44 133.306 115.097C133.962 115.754 133.962 116.864 133.283 117.521Z"
                        fill="white"
                      />
                    </g>
                    <path
                      d="M61.99 191.17C61.99 191.777 61.8495 192.291 61.5676 192.711C61.2866 193.131 60.9107 193.458 60.4418 193.692C59.9728 193.926 59.4098 194.019 58.7995 194.019H53.9676V188.181H58.9409C59.5504 188.181 60.1133 188.321 60.5357 188.555C61.0047 188.834 61.3332 189.162 61.5676 189.629C61.8495 190.096 61.99 190.609 61.99 191.17ZM61.0987 183.137C61.0987 183.651 60.9581 184.117 60.7236 184.491C60.4891 184.865 60.1607 185.145 59.7849 185.378C59.4099 185.565 58.9409 185.659 58.4245 185.659H53.9202V180.661H58.4245C59.2219 180.661 59.8788 180.895 60.3478 181.362C60.8642 181.876 61.0987 182.436 61.0987 183.137ZM61.8961 186.873C62.3651 186.593 62.7875 186.219 63.1159 185.753C63.6323 185.051 63.8668 184.164 63.8668 183.137C63.8668 182.296 63.6788 181.502 63.2572 180.755C62.8348 180.008 62.2719 179.4 61.4737 178.886C60.6763 178.42 59.6909 178.186 58.5185 178.186H51.2461V196.587H59.2219C60.3952 196.587 61.3805 196.354 62.2245 195.934C63.0693 195.467 63.6789 194.86 64.1012 194.065C64.5236 193.272 64.7581 192.338 64.7581 191.263C64.7581 190.143 64.4297 189.162 63.8202 188.321C63.3038 187.667 62.6469 187.2 61.8961 186.873ZM76.159 189.909C76.159 190.143 76.159 190.376 76.1124 190.703C76.1124 191.217 76.0184 191.684 75.8779 192.104C75.7839 192.572 75.5495 192.992 75.221 193.412C74.8926 193.833 74.4228 194.159 73.9072 194.44C73.3443 194.719 72.6874 194.86 71.9366 194.86C71.3736 194.86 70.9046 194.767 70.5288 194.579C70.1538 194.392 69.8719 194.159 69.6848 193.879C69.4969 193.599 69.403 193.225 69.403 192.898C69.403 192.524 69.4969 192.197 69.6374 191.964C69.8254 191.731 70.0133 191.497 70.2943 191.31C70.5762 191.123 70.9046 190.983 71.2797 190.843C71.7021 190.703 72.2176 190.609 72.7813 190.47C73.3443 190.376 73.9538 190.283 74.6581 190.189C75.1736 190.049 75.6426 189.956 76.159 189.909ZM76.4874 196.587H78.8805V188.087C78.8805 187.527 78.8331 186.966 78.7865 186.453C78.7392 185.939 78.5986 185.472 78.3641 185.005C77.9417 184.071 77.2848 183.417 76.3469 182.997C75.4081 182.576 74.3296 182.343 73.1098 182.343C71.5142 182.343 70.2477 182.67 69.2624 183.37C68.2771 184.071 67.6668 185.005 67.2917 186.173L69.778 186.92C70.0133 186.126 70.4349 185.612 71.0452 185.239C71.6547 184.912 72.3116 184.725 73.0624 184.725C74.2357 184.725 75.0331 185.005 75.5021 185.519C75.9245 185.986 76.159 186.639 76.2063 187.527C75.69 187.621 75.1736 187.667 74.6107 187.761C73.7659 187.9 72.9219 187.994 72.1711 188.134C71.3736 188.275 70.7167 188.414 70.0599 188.601C69.3564 188.834 68.7461 189.115 68.2771 189.489C67.8081 189.862 67.4323 190.329 67.1512 190.843C66.9167 191.357 66.7754 191.964 66.7754 192.665C66.7754 193.412 66.9633 194.112 67.2917 194.719C67.6668 195.326 68.1831 195.84 68.8866 196.214C69.5909 196.587 70.4349 196.775 71.4676 196.775C72.7814 196.775 73.8599 196.494 74.7512 195.98C75.4081 195.607 75.9711 195.046 76.4874 194.346V196.587ZM84.9796 193.131C84.3227 192.244 83.9943 191.123 83.9943 189.675C83.9943 188.741 84.1348 187.948 84.4167 187.2C84.6978 186.5 85.1202 185.939 85.6831 185.519C86.246 185.098 86.9503 184.912 87.8417 184.912C88.6391 184.912 89.296 185.145 89.9055 185.565C90.5158 185.986 90.9382 186.593 91.2193 187.387L93.8934 186.639C93.565 185.332 92.8615 184.305 91.7822 183.557C90.7037 182.81 89.4365 182.436 87.8883 182.436C86.4805 182.436 85.2607 182.763 84.2754 183.37C83.2908 183.978 82.4926 184.865 81.977 185.939C81.4607 187.014 81.1788 188.275 81.1322 189.722C81.1322 191.123 81.4141 192.384 81.9297 193.458C82.446 194.579 83.1969 195.42 84.2288 196.074C85.2141 196.681 86.4339 197.008 87.8417 197.008C89.3426 197.008 90.6098 196.635 91.6417 195.934C92.6736 195.233 93.4244 194.159 93.8934 192.851L91.1727 192.197C90.8908 192.945 90.4685 193.506 89.9529 193.926C89.4365 194.299 88.7331 194.533 87.8417 194.533C86.5745 194.44 85.6365 194.019 84.9796 193.131ZM96.1925 196.587H98.9141V178.186H96.2399L96.1925 196.587ZM108.344 196.261V194.112C108.344 193.926 108.204 193.785 108.016 193.785H106.468C105.951 193.785 105.529 193.365 105.529 192.851V191.31C105.529 191.123 105.388 190.983 105.201 190.983H103.653C103.136 190.983 102.714 190.563 102.714 190.049V189.115C102.714 188.601 103.136 188.181 103.653 188.181H105.201C105.388 188.181 105.529 188.041 105.529 187.854V186.453C105.529 185.939 105.951 185.519 106.468 185.519H108.016C108.204 185.519 108.344 185.192 108.344 185.192V183.044C108.344 182.856 108.204 182.717 108.016 182.717H105.857C105.67 182.717 105.529 182.856 105.529 183.044V184.585C105.529 185.098 105.107 185.519 104.591 185.519H103.043C102.855 185.519 102.714 185.659 102.714 185.846V187.387C102.714 187.9 102.292 188.321 101.776 188.321H100.228C100.04 188.321 99.8994 188.461 99.8994 188.648V190.797C99.8994 190.983 100.04 191.123 100.228 191.123H101.776C102.292 191.123 102.714 191.544 102.714 192.058V193.599C102.714 193.785 102.855 193.926 103.043 193.926H104.591C105.107 193.926 105.529 194.346 105.529 194.86V196.401C105.529 196.587 105.67 196.728 105.857 196.728H108.016C108.204 196.587 108.344 196.448 108.344 196.261ZM120.73 196.587H123.123V182.81H120.402V190.002C120.402 190.843 120.308 191.497 120.12 192.104C119.933 192.665 119.698 193.131 119.37 193.506C119.042 193.833 118.666 194.112 118.243 194.253C117.822 194.392 117.352 194.486 116.883 194.486C116.132 194.486 115.569 194.346 115.1 194.019C114.631 193.739 114.303 193.319 114.021 192.851C113.786 192.384 113.599 191.824 113.505 191.263C113.411 190.703 113.364 190.143 113.364 189.629V182.856H110.643V190.516C110.643 190.936 110.69 191.45 110.737 192.011C110.83 192.572 110.972 193.131 111.159 193.739C111.393 194.346 111.675 194.86 112.098 195.374C112.52 195.887 113.036 196.261 113.693 196.587C114.349 196.915 115.147 197.055 116.086 197.055C117.352 197.055 118.385 196.775 119.276 196.261C119.792 195.934 120.261 195.514 120.683 195.046V196.587H120.73ZM135.509 189.675C135.509 190.609 135.368 191.404 135.087 192.151C134.805 192.898 134.383 193.458 133.82 193.926C133.257 194.346 132.554 194.579 131.709 194.579C130.817 194.579 130.114 194.392 129.551 193.972C128.987 193.552 128.566 192.992 128.331 192.244C128.096 191.497 128.096 191.497 127.955 189.722C127.955 188.788 128.096 187.948 128.331 187.2C128.612 186.453 128.987 185.892 129.551 185.472C130.114 185.051 130.771 184.865 131.615 184.865C132.506 184.865 133.257 185.098 133.82 185.519C134.383 185.939 134.805 186.546 135.087 187.247C135.368 187.948 135.509 188.788 135.509 189.675ZM137.573 193.412C138.09 192.291 138.324 191.077 138.324 189.675C138.324 188.275 138.09 187.06 137.573 185.939C137.057 184.865 136.354 183.978 135.368 183.324C134.43 182.67 133.304 182.39 131.991 182.39C130.677 182.39 129.598 182.717 128.706 183.324C128.424 183.51 128.19 183.744 127.909 183.978V182.717H125.516V202.659H128.19V195.56C128.33 195.701 128.518 195.84 128.659 195.934C129.551 196.587 130.677 196.914 131.991 196.914C133.304 196.914 134.383 196.587 135.322 195.934C136.354 195.374 137.104 194.486 137.573 193.412ZM140.67 196.587H151.133V195.14H142.172V178.186H140.717V196.587H140.67ZM164.598 190.563H157.091L160.844 180.008L164.598 190.563ZM166.709 196.587H168.257L161.689 178.186H159.859L153.291 196.587H154.839L156.481 191.964H164.973L166.709 196.587ZM182.004 191.59C182.004 192.338 181.816 192.992 181.441 193.506C181.066 194.019 180.549 194.44 179.892 194.719C179.235 195 178.485 195.14 177.687 195.14H172.058V187.621H178.11C178.86 187.621 179.517 187.807 180.08 188.134C180.691 188.508 181.16 188.975 181.488 189.582C181.816 190.189 182.004 190.843 182.004 191.59ZM179.377 185.753C178.86 186.032 178.251 186.219 177.594 186.219H172.01V179.634H177.594C178.579 179.634 179.423 179.914 180.08 180.522C180.737 181.082 181.066 181.876 181.066 182.81C181.066 183.464 180.925 184.071 180.597 184.585C180.315 185.051 179.892 185.472 179.377 185.753ZM180.362 186.826C180.925 186.5 181.441 186.08 181.816 185.519C182.379 184.725 182.66 183.837 182.66 182.856C182.66 181.969 182.426 181.175 182.004 180.475C181.582 179.774 180.972 179.214 180.174 178.84C179.423 178.42 178.532 178.233 177.594 178.233H170.51V196.635H178.11C179.142 196.635 180.08 196.448 180.925 196.028C181.769 195.607 182.379 195.046 182.848 194.299C183.317 193.552 183.552 192.618 183.552 191.59C183.552 190.329 183.177 189.255 182.473 188.414C181.957 187.667 181.254 187.153 180.362 186.826ZM197.862 183.464L199.41 183.183C199.222 182.063 198.847 181.129 198.191 180.334C197.58 179.541 196.783 178.934 195.797 178.466C194.812 178.046 193.733 177.812 192.513 177.812C191.293 177.812 190.261 178 189.323 178.42C188.385 178.84 187.681 179.4 187.118 180.148C186.602 180.895 186.32 181.736 186.32 182.763C186.32 183.324 186.414 183.837 186.602 184.258C186.79 184.725 187.024 185.098 187.353 185.472C187.681 185.846 188.103 186.126 188.572 186.406C189.041 186.687 189.604 186.92 190.215 187.06L194.86 188.461C195.188 188.555 195.516 188.695 195.891 188.834C196.266 188.975 196.595 189.162 196.923 189.442C197.252 189.675 197.486 190.002 197.721 190.376C197.909 190.75 198.003 191.217 198.003 191.777C198.003 192.524 197.768 193.225 197.346 193.785C196.923 194.346 196.314 194.813 195.563 195.14C194.812 195.467 193.921 195.607 192.935 195.607C191.481 195.607 190.215 195.233 189.182 194.533C188.15 193.833 187.447 192.851 187.165 191.637L185.664 191.87C185.898 192.945 186.32 193.833 186.977 194.626C187.634 195.374 188.479 195.98 189.51 196.401C190.543 196.821 191.669 197.008 192.935 197.008C193.921 197.008 194.766 196.868 195.61 196.635C196.408 196.401 197.111 196.028 197.721 195.607C198.331 195.14 198.753 194.579 199.082 193.926C199.41 193.272 199.551 192.524 199.551 191.684C199.551 190.843 199.41 190.143 199.082 189.536C198.753 188.975 198.378 188.508 197.909 188.181C197.44 187.854 196.971 187.573 196.454 187.387C195.985 187.2 195.563 187.06 195.188 186.966L191.481 185.846C190.965 185.705 190.449 185.519 189.933 185.285C189.37 185.051 188.948 184.725 188.572 184.351C188.197 183.931 188.01 183.417 188.01 182.717C188.01 182.063 188.197 181.456 188.619 180.942C188.995 180.428 189.558 180.008 190.261 179.681C190.965 179.354 191.763 179.214 192.654 179.214C193.592 179.214 194.437 179.4 195.188 179.727C195.938 180.054 196.595 180.568 197.065 181.175C197.44 181.876 197.768 182.623 197.862 183.464Z"
                      fill="white"
                    />
                  </g>
                  <defs>
                    <filter
                      id="filter0_d_100_4963"
                      x="72.9062"
                      y="72.1875"
                      width="104.987"
                      height="104.988"
                      filterUnits="userSpaceOnUse"
                      color-interpolation-filters="sRGB"
                    >
                      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                      <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                      />
                      <feOffset dy="2"/>
                      <feGaussianBlur stdDeviation="8"/>
                      <feComposite in2="hardAlpha" operator="out"/>
                      <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.101961 0 0 0 0 0.101961 0 0 0 0 0.101961 0 0 0 0.06 0"
                      />
                      <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_100_4963"
                      />
                      <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_100_4963"
                        result="shape"
                      />
                    </filter>
                    <linearGradient
                      id="paint0_linear_100_4963"
                      x1="5.89948"
                      y1="269.391"
                      x2="304.168"
                      y2="73.151"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#51A9FF"/>
                      <stop offset="0.2" stop-color="white" stop-opacity="0"/>
                      <stop offset="0.8" stop-color="white" stop-opacity="0"/>
                      <stop offset="1" stop-color="#6CC4FF"/>
                    </linearGradient>
                    <linearGradient
                      id="paint1_linear_100_4963"
                      x1="6.21094"
                      y1="0.000579876"
                      x2="289.191"
                      y2="234.165"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#6EC6FF"/>
                      <stop offset="1" stop-color="#50A8FF"/>
                    </linearGradient>
                  </defs>
                </svg>
              </div>

              {[1, 2, 3, 4, 5, 6].map((item) => (
                <div className={`anim-about__item anim-about__item--pos-${item}`}>
                  <div className="anim-about__item-icons">
                    <img src="" alt="" className="anim-about__item-brand"/>
                    <img
                      src={cross}
                      alt=""
                      className="anim-about__item-status anim-about__item-status--danger"
                    />
                    <img
                      src={tick}
                      alt=""
                      className="anim-about__item-status anim-about__item-status--success"
                    />
                  </div>
                  <p className="anim-about__item-name"></p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default AuthRightAnimation;
